import { gql } from '@apollo/client'

export const GET_RENT_CATEGORY_TERMS = gql`
  query getRentCategoryTerms($id: ID!) {
    rentCategory(id: $id) {
      individualTerms
    }
  }
`
